import { CALCULATE_ORDER_ITEM_VALUE } from "@/static/calculateOrderItemValueTypes";
import { Expose } from "class-transformer";
import { IsNumber } from "class-validator";

export class OrderGetTemporaryCalculateValueRequest {
  Quantity: number;
  Value: number;
  VAT: string;
  ExchangeRate: number;
  CalculateType: CALCULATE_ORDER_ITEM_VALUE;

  constructor(
    quantity: number,
    value: number,
    vat: string,
    exchangeRate: number,
    calculateType: CALCULATE_ORDER_ITEM_VALUE
  ) {
    this.Quantity = quantity;
    this.Value = value;
    this.VAT = vat;
    this.ExchangeRate = exchangeRate;
    this.CalculateType = calculateType;
  }
}

export class OrderGetTemporaryCalculateValueResponse {
  @IsNumber()
  @Expose()
  quantity!: number;
  @IsNumber()
  @Expose()
  netPrice!: number;
  @IsNumber()
  @Expose()
  netPriceInCurrency!: number;
  @IsNumber()
  @Expose()
  netValue!: number;
  @IsNumber()
  @Expose()
  netValueInCurrency!: number;
  @IsNumber()
  @Expose()
  vatAmount!: number;
  @IsNumber()
  @Expose()
  vatAmountInCurrency!: number;
  @IsNumber()
  @Expose()
  gross!: number;
  @IsNumber()
  @Expose()
  grossInCurrency!: number;
  @IsNumber()
  @Expose()
  modifier!: number;
}
